import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dialog } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
export const HelpDialog = forwardRef(function HelpDialog(props, forwardedRef) {
    return (_jsx(Dialog, { ...props, ref: forwardedRef, className: twMerge('ppl-HelpDialog max-w-[40ch] rounded bg-inverse px-3 py-2 text-body-md text-inverse-default shadow-lg outline-none', props.className) }));
});
//# sourceMappingURL=HelpDialog.js.map